import React, { useState, useEffect } from 'react';
import { Settings, Loader2, Save, Lock, User, Key } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const AdminSettings = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', new_password: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) { setForm({ name: user.name || '', email: user.email || '', new_password: '' }); }
  }, [user]);

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const data = {};
      if (form.name !== user.name) data.name = form.name;
      if (form.email !== user.email) data.email = form.email;
      if (form.new_password) data.new_password = form.new_password;
      if (!Object.keys(data).length) { toast.error('No changes to save'); return; }
      await api('/api/admin/profile', { method: 'PUT', body: JSON.stringify(data) });
      toast.success('Profile updated! Please re-login if you changed email/password.');
      setForm({ ...form, new_password: '' });
    } catch (err) { toast.error(err.message); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings" className="max-w-lg space-y-6">
      <h1 className="font-heading text-3xl font-bold text-white">My Settings</h1>
      <form onSubmit={handleSave} className="card p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">Name</label>
          <input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="settings-name" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">Email</label>
          <input type="email" className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="settings-email" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">New Password (leave empty to keep current)</label>
          <input type="password" className="input" placeholder="New password..." value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="settings-password" />
        </div>
        <button type="submit" disabled={saving} className="btn-primary w-full" data-testid="save-settings-btn">
          {saving && <Loader2 className="w-4 h-4 animate-spin inline mr-2" />}Save Changes
        </button>
      </form>
    </div>
  );
};

// ===================== PROTECTED ROUTE =====================


export default AdminSettings;
